import { ActionPayload } from '../config/types';

export function isHQxWeSpaceFromIMS(params: ActionPayload | null | undefined): false | boolean {
  return params?.type === 'FLOOR' && !params?.locationCode;
}

export function isAvailableForHolds(params: ActionPayload | null | undefined): boolean {
  return !!params?.available && !params?.paperworkPending && !isHQxWeSpaceFromIMS(params);
}
